import store from '@/store';

export const isEnv: boolean = process.env.NODE_ENV === 'development';

export const host: string = isEnv ? 'http://192.168.3.150' : location.origin;
// export const host: string = store.state.config.host? store.state.config.host : ( isEnv ? 'https://zyfw.prdtest.51fjb.cn' : location.origin );

export const ImgUrlFix :string = location.origin + location.pathname.replace('/index.html', '')
